/*
 * INO Beauty - Sepet tutari esigi gecince ucretsiz hediye (Iconic Bag)
 *
 * Esik tutari ve hediye urunu TEMA DUZENLEYICIDEN yonetilir:
 *   Tema duzenleyici > Sepet cekmecesi (Cart drawer) > "Ucretsiz Hediye"
 * Ayarlar sections/cart-drawer.liquid icinde window.inoFreeGift olarak her
 * sayfaya (sepet sayfasi dahil) basilir; bu dosyada sabit esik/urun yoktur.
 *
 * Urun ara toplami (hediye haric, kupon/kargo haric) esigi gectiginde hediyeyi
 * sepete otomatik ekler, esigin altina dustugunde otomatik cikarir.
 * FoxEcom Sleek temasinin native sepet akisini (cartUpdate pubsub) kullanir.
 *
 * Not: Hediyenin checkout'ta 0 TL olmasi Shopify Admin > Indirimler'deki
 * "iconicbag_gift" otomatik indiriminden gelir. Esik degistiginde oradaki
 * minimum tutar da ayni yapilmalidir.
 *
 * Kendi Setini Yap set hediyesi (canvas canta, Agentcy 30.10.2026):
 * Sepette en az `setGiftMin` urunluk bir "Kendi Setin" (_mys) grubu varsa
 * window.inoMysSetGift.variantId cantasindan 1 adet (_mys_set_gift) tutulur,
 * set bozulursa cikarilir. 0 TL olmasi "INO Kendi Setini Yap" indirim
 * fonksiyonundan gelir. Bu satir Iconic Bag esigine sayilmaz.
 * Iconic Bag esigi Kendi Setin satirlarinda set indirimi SONRASI odenecek tutara bakar
 * (sunucudaki teklif motorundan; eligibleForGift).
 * Exclusive canta (ino_mys.config -> exclusiveGift): Kendi Setin secimi Ultimate / Full Glam ile birebir
 * ayniysa canvas yerine 1 adet (_mys_ex_gift) tutulur; secim degisince cikarilir, canvas geri gelir.
 * Siparis raporlamasi: set varken sepete "Kendi Setini Yap" ozelligi (cart attribute) yazilir;
 * admin'de siparisin "Ek bilgiler" alaninda ve siparis disa aktariminda (Note Attributes) gorunur.
 */
(function () {
  if (window.__inoFreeGiftInit) return;
  window.__inoFreeGiftInit = true;

  function cfg() { return window.inoFreeGift || null; }
  function threshold() { var c = cfg(); return c ? Number(c.threshold) || 0 : 0; }
  function giftVariantId() { var c = cfg(); return c ? Number(c.variantId) || 0 : 0; }
  function isActive() { var c = cfg(); return !!(c && c.active && threshold() > 0 && giftVariantId() > 0); }

  function isAutoGift(it) {
    return !!(it && it.properties && it.properties._ino_free_gift === 'true');
  }
  function isGiftLine(it) {
    var vid = giftVariantId();
    return isAutoGift(it) || (vid > 0 && it.variant_id === vid);
  }

  function isSetGiftLine(it) {
    return !!(it && it.properties && it.properties._mys_set_gift === 'true');
  }
  // Exclusive canta (Ultimate / Full Glam ile birebir ayni secime canvas yerine verilir)
  var exInfo = null; // sections/ino-mys-quote -> data-mys-ex
  function isExLine(it) {
    return !!(it && it.properties && it.properties._mys_ex_gift === 'true');
  }
  function isBagGift(it) { return isSetGiftLine(it) || isExLine(it); }
  function setGiftCfg() { return window.inoMysSetGift || {}; }
  function setGiftVariantId() { return Number(setGiftCfg().variantId) || 0; }

  // En az setGiftMin urunluk bir Kendi Setin grubu var mi? (hediye satirlari sayilmaz)
  function hasQualifyingSet(cart) {
    var min = Number(setGiftCfg().min) || 2;
    var groups = {};
    ((cart && cart.items) || []).forEach(function (it) {
      var gid = it.properties && it.properties._mys;
      if (!gid || isGiftLine(it) || isBagGift(it)) return;
      groups[gid] = (groups[gid] || 0) + it.quantity;
    });
    return Object.keys(groups).some(function (k) { return groups[k] >= min; });
  }

  // Esige sayilan tutar: hediyeler haric. Kendi Setin (_mys) satirlari set indirimi SONRASI
  // odenen tutarla (final_line_price) sayilir; Iconic Bag ancak odenen tutar esigi gecince gelir.
  function eligibleTotal(cart) {
    return ((cart && cart.items) || []).reduce(function (sum, it) {
      if (isGiftLine(it) || isBagGift(it)) return sum;
      var paid = it.properties && it.properties._mys && it.final_line_price != null ? it.final_line_price : it.original_line_price;
      return sum + paid;
    }, 0);
  }

  // Kendi Setin gruplarinin odenecek tutari sunucudaki teklif motorundan (sections/ino-mys-quote).
  // Sepette hangi indirimin kazandigindan bagimsizdir: set indirimi "iconicbag_gift" ile birlesmedigi
  // icin Shopify bazen digerini secer; o zaman final_line_price yaniltir.
  var quoteCache = {};
  var quoteInfo = {};
  function mysGroups(cart) {
    var groups = {};
    ((cart && cart.items) || []).forEach(function (it) {
      var gid = it.properties && it.properties._mys;
      if (!gid || isGiftLine(it) || isBagGift(it)) return;
      var g = groups[gid] = groups[gid] || { qty: {}, fallback: 0 };
      g.qty[it.variant_id] = (g.qty[it.variant_id] || 0) + it.quantity;
      g.fallback += it.final_line_price != null ? it.final_line_price : it.original_line_price;
    });
    return Object.keys(groups).map(function (k) { return groups[k]; });
  }
  function groupKey(group) {
    return Object.keys(group.qty).sort().map(function (v) { return v + '*' + group.qty[v]; }).join('~');
  }
  function quotePay(group) {
    var key = groupKey(group);
    if (key in quoteCache) return Promise.resolve(quoteCache[key]);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'search/suggest?q=' + encodeURIComponent('MYSQ~' + key) + '&resources[type]=page&resources[limit]=1&section_id=ino-mys-quote';
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-mys-json[^>]*>([\s\S]*?)<\/script>/);
        var j = m ? JSON.parse(m[1]) : null;
        var pay = j && j.ok && j.valid ? Number(j.pay) : null;
        if (pay != null) { quoteCache[key] = pay; quoteInfo[key] = { pct: Number(j.pct) || 0, units: Number(j.units) || 0, exact: j.exact || null }; }
        var mx = html.match(/<script[^>]*data-mys-ex[^>]*>([\s\S]*?)<\/script>/);
        if (mx) { try { var ex = JSON.parse(mx[1]); if (ex && ex.variantId) exInfo = ex; } catch (e) { /* yok say */ } }
        return pay;
      })
      .catch(function () { return null; });
  }
  // Iconic Bag esigi icin tutar: hediyeler haric; set satirlari odenecek tutarla, digerleri ayni tabanla.
  function eligibleForGift(cart) {
    var base = ((cart && cart.items) || []).reduce(function (sum, it) {
      if (isGiftLine(it) || isBagGift(it) || (it.properties && it.properties._mys)) return sum;
      return sum + it.original_line_price;
    }, 0);
    var groups = mysGroups(cart);
    if (!groups.length) return Promise.resolve(base);
    return Promise.all(groups.map(function (g) {
      return quotePay(g).then(function (p) { return p == null ? g.fallback : p; });
    })).then(function (pays) { return pays.reduce(function (s, p) { return s + p; }, base); });
  }

  // Siparis "Ek bilgiler" alani (cart attribute) - raporlama icin Kendi Setini Yap ozeti.
  // Yalnizca bilgi amaclidir; indirimi ve hediyeleri her zaman fonksiyon belirler.
  var MYS_ATTR = 'Kendi Setini Yap';
  // Sepette Exclusive cantali hazir setle birebir ayni bir grup var mi / canvas hak eden baska grup var mi
  function bagNeeds(cart) {
    var min = Number(setGiftCfg().min) || 2;
    var out = { ex: false, plain: false };
    mysGroups(cart).forEach(function (g) {
      var units = Object.keys(g.qty).reduce(function (s, v) { return s + g.qty[v]; }, 0);
      if (units < min) return;
      var q = quoteInfo[groupKey(g)];
      if (exInfo && exInfo.available && q && q.exact && (exInfo.sets || []).indexOf(q.exact) > -1) out.ex = true;
      else out.plain = true;
    });
    return out;
  }

  function mysAttrValue(cart, setOk, iconicOk, exOk) {
    if (!setOk && !exOk) return '';
    var parts = mysGroups(cart).map(function (g) {
      var units = Object.keys(g.qty).reduce(function (s, v) { return s + g.qty[v]; }, 0);
      var q = quoteInfo[groupKey(g)];
      return units + ' ürün' + (q && q.pct ? ' · %' + q.pct + ' set indirimi' : '');
    });
    var bags = [];
    if (exOk) bags.push('Exclusive çanta');
    if (setOk) bags.push('Canvas çanta');
    if (iconicOk) bags.push('Iconic Bag');
    return 'Evet · ' + parts.join(' | ') + ' · Hediye: ' + bags.join(' + ');
  }

  function formatMoney(cents) {
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    }
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL';
  }
  function formatMoneyShort(cents) {
    return String(formatMoney(cents)).replace(/[.,]00(?=[^0-9]*$)/, '');
  }

  // Sepet basligindaki hediye esik cubugu (snippets/free-gift-goal.liquid).
  // Drawer basligi section render'inda yenilenmedigi icin cart:updated
  // olayiyla guncellenir (free-shipping-goal ile ayni desen). Esik, urun adi ve
  // gorseli window.inoFreeGift'ten senkronlanir (sepet sayfasi dahil).
  if (window.customElements && !customElements.get('free-gift-goal')) {
    customElements.define(
      'free-gift-goal',
      class extends HTMLElement {
        connectedCallback() {
          this.onCartUpdated = this.onCartUpdated || this.handleCartUpdated.bind(this);
          document.addEventListener('cart:updated', this.onCartUpdated);
          this.update(Number(this.dataset.eligibleTotal) || 0);
        }
        disconnectedCallback() {
          document.removeEventListener('cart:updated', this.onCartUpdated);
        }
        handleCartUpdated(event) {
          var cart = event && event.detail && event.detail.cart;
          if (!cart || !cart.items) return;
          this.update(eligibleTotal(cart));
        }
        update(amount) {
          var c = cfg();
          if (c && !isActive()) {
            this.classList.add('hidden');
            return;
          }
          var min = threshold() || Number(this.dataset.minimumAmount) || 0;
          if (min <= 0) return;
          this.classList.toggle('hidden', amount <= 0);
          this.classList.toggle('free-gift-goal--done', amount >= min);
          var bar = this.querySelector('progress-bar');
          if (bar) bar.style.setProperty('--percent', Math.min((amount * 100) / min, 100) + '%');
          if (amount < min) {
            var left = this.querySelector('[data-left-to-spend]');
            if (left) left.innerHTML = formatMoney(min - amount);
          }
          if (c) {
            var th = this.querySelector('[data-threshold-amount]');
            if (th) th.innerHTML = formatMoneyShort(min);
            var title = this.querySelector('.free-gift-goal__preview-title');
            if (title && c.productTitle) title.textContent = c.productTitle;
            var img = this.querySelector('.free-gift-goal__preview-image');
            if (img && c.productImage) {
              img.src = c.productImage;
              if (c.productTitle) img.alt = c.productTitle;
            }
          }
        }
      }
    );
  }

  // Not: tema duzenleyicide (designMode) de calisir; boylece editor onizlemesinde de hediyeler otomatik eklenir.

  function whenReady(cb) {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.routes && FoxTheme.utils) return cb();
    var tries = 0;
    var timer = setInterval(function () {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.routes && FoxTheme.utils) {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 150);
  }

  whenReady(function () {
    var working = false;

    function fetchCfg(type) {
      try { return FoxTheme.utils.fetchConfig(type || 'json'); }
      catch (e) {
        return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      }
    }

    function rootUrl() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function bundledSections() {
      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );
      return sections;
    }

    function getCart() {
      return fetch(FoxTheme.routes.cart_url, { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });
    }

    // Sepeti yeniden cek, render edilmis section'lari ekle ve temanin
    // cartUpdate olayini yayinla -> drawer + header sayaci native guncellenir.
    function broadcast(operationResponse) {
      return getCart().then(function (cart) {
        if (operationResponse && operationResponse.sections) cart.sections = operationResponse.sections;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'ino-free-gift', cart: cart });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
        return cart;
      });
    }

    function addGift(items) {
      var body = JSON.stringify({
        items: items,
        sections: bundledSections(),
        sections_url: window.location.pathname
      });
      return fetch(FoxTheme.routes.cart_add_url, Object.assign({}, fetchCfg('json'), { body: body }))
        .then(function (r) { return r.json(); })
        .then(broadcast);
    }

    // Satir anahtari (key) -> yeni adet. Birden fazla hediye satirini tek
    // istekte duzeltir (urun degistiginde eski hediye satiri da kalkar).
    function updateLines(updates) {
      var body = JSON.stringify({
        updates: updates,
        sections: bundledSections(),
        sections_url: window.location.pathname
      });
      return fetch(rootUrl() + 'cart/update.js', Object.assign({}, fetchCfg('json'), { body: body }))
        .then(function (r) { return r.json(); })
        .then(broadcast);
    }

    function reconcile(knownCart) {
      if (working) return Promise.resolve();
      if (!cfg()) return Promise.resolve();
      var source = knownCart && knownCart.items ? Promise.resolve(knownCart) : getCart();
      working = true;
      return source.then(function (cart) {
        return eligibleForGift(cart).then(function (elig) { return { cart: cart, elig: elig }; });
      }).then(function (st) {
        working = false;
        var cart = st.cart;
        var items = (cart && cart.items) || [];
        var vid = giftVariantId();
        var giftLines = items.filter(isGiftLine);
        var hasOtherItems = items.some(function (it) { return !isGiftLine(it) && !isBagGift(it); });
        var qualifies = isActive() && hasOtherItems && st.elig >= threshold();
        var sgVid = setGiftVariantId();
        var needs = bagNeeds(cart);
        var exVid = needs.ex && exInfo ? Number(exInfo.variantId) : 0;
        // Canvas: Exclusive'e girmeyen bir set varsa (Exclusive cantasi tukenmisse de canvas verilir)
        var setQualifies = sgVid > 0 && hasQualifyingSet(cart) && (needs.plain || !exVid);

        var updates = {};
        var changed = false;
        var keep = null;
        giftLines.forEach(function (line) {
          if (qualifies && !keep && line.variant_id === vid) {
            keep = line;
            if (line.quantity !== 1) { updates[line.key] = 1; changed = true; }
          } else {
            updates[line.key] = 0;
            changed = true;
          }
        });
        var needAdd = qualifies && !keep;

        // Set hediyesi (canvas canta): set varken 1 adet, yoksa hic
        var keepSet = null;
        items.filter(isSetGiftLine).forEach(function (line) {
          if (setQualifies && !keepSet && line.variant_id === sgVid) {
            keepSet = line;
            if (line.quantity !== 1) { updates[line.key] = 1; changed = true; }
          } else {
            updates[line.key] = 0;
            changed = true;
          }
        });
        var needAddSet = setQualifies && !keepSet;

        // Exclusive canta: birebir Ultimate / Full Glam seciminde 1 adet, yoksa hic
        var keepEx = null;
        items.filter(isExLine).forEach(function (line) {
          if (exVid && !keepEx && line.variant_id === exVid) {
            keepEx = line;
            if (line.quantity !== 1) { updates[line.key] = 1; changed = true; }
          } else {
            updates[line.key] = 0;
            changed = true;
          }
        });
        var needAddEx = !!exVid && !keepEx;

        var attrVal = mysAttrValue(cart, setQualifies, qualifies, !!exVid);
        var attrNow = (cart.attributes && cart.attributes[MYS_ATTR]) || '';
        var legacy = !!(cart.attributes && cart.attributes['Kendi Seti']);
        var attrStep = function () {
          if (attrVal === attrNow && !legacy) return;
          var a = {}; a[MYS_ATTR] = attrVal;
          if (legacy) a['Kendi Seti'] = '';
          return fetch(rootUrl() + 'cart/update.js', Object.assign({}, fetchCfg('json'), { body: JSON.stringify({ attributes: a }) }))
            .catch(function () {});
        };
        if (!changed && !needAdd && !needAddSet && !needAddEx) return attrStep();

        var toAdd = [];
        if (needAddEx) toAdd.push({ id: exVid, quantity: 1, properties: { 'Set': 'Kendi Setin · Hediye', _mys_ex_gift: 'true' } });
        if (needAddSet) toAdd.push({ id: sgVid, quantity: 1, properties: { 'Set': 'Kendi Setin · Hediye', _mys_set_gift: 'true' } });
        if (needAdd) toAdd.push({ id: giftVariantId(), quantity: 1, properties: { _ino_free_gift: 'true' } });

        working = true;
        var step = changed ? updateLines(updates) : Promise.resolve();
        return step
          .then(function () { if (toAdd.length) return addGift(toAdd); })
          .then(attrStep)
          .finally(function () { working = false; });
      }).catch(function () { working = false; });
    }

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (working) return;
      if (event && event.source === 'ino-free-gift') return;
      reconcile(event && event.cart && event.cart.items ? event.cart : null);
    });

    document.addEventListener('cart:refresh', function () {
      if (working) return;
      setTimeout(function () { reconcile(); }, 700);
    });

    window.addEventListener('pageshow', function () { reconcile(); });

    // "Hemen Satin Al" (dynamic checkout) sepeti atlayip dogrudan checkout'a
    // gidiyor. Yakalayip once urunu sepete ekliyoruz; reconcile hediyeyi ekler;
    // ardindan checkout'a yonlendiriyoruz. Boylece hizli satin alma yolunda da
    // esik ustu hediye uygulanir.
    function buyNowThenCheckout(form, btn) {
      var fd;
      try { fd = new FormData(form); } catch (e) { window.location.href = '/cart'; return; }
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.pointerEvents = 'none'; btn.style.opacity = '0.7'; }
      fetch(FoxTheme.routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status && res.status !== 200) throw new Error('add-failed');
          return reconcile();
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart'; });
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('.shopify-payment-button__button--unbranded');
      if (!btn) return;
      var form = btn.closest('form[action*="/cart"]') || btn.closest('form');
      if (!form) return;
      var idEl = form.querySelector('[name="id"]');
      if (!idEl || !idEl.value || idEl.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      buyNowThenCheckout(form, btn);
    }, true);

    reconcile();
  });
})();

/*
 * Hediye satirlari sepette kart gibi (Agentcy 30.10.2026): Iconic Bag (_ino_free_gift), canvas canta
 * (_mys_set_gift) ve Exclusive canta (_mys_ex_gift, "Kendi Setin · Hediye") sepet cekmecesinde ve sepet
 * sayfasinda adet degistirilemez, silinemez; yerinde "Hediye · 1 adet" etiketi gorunur. Hediyeleri yine
 * yukaridaki reconcile ekler / cikarir (set bozulursa ya da esik altina dusulurse kendiliginden gider).
 */
(function () {
  if (window.__inoGiftLock) return;
  window.__inoGiftLock = true;
  var CSS =
    '.cart-item--free-gift quantity-input,.cart-item--free-gift .cart-quantity,.cart-item--free-gift [is="cart-remove-item"],' +
    '.cart-item--free-gift .cart-item__remove,.cart-item--free-gift .quantity__rules{display:none !important}' +
    'li.cart-item--free-gift{background:#f3faf6;border:1px solid #d4ece0;border-radius:1.2rem;padding:1.2rem !important}' +
    'tr.cart-item--free-gift>td{background:#f3faf6}' +
    '.cart-item__gift-lock{display:inline-flex;align-items:center;gap:.4rem;min-height:3.6rem;padding:0 1.2rem;border-radius:1.8rem;' +
    'background:#e5f4ee;color:#008c62;font-size:1.3rem;font-weight:600;white-space:nowrap}' +
    '.cart-item__gift-lock svg{width:1.4rem;height:1.4rem}' +
    // Yedek rozet (temada hediye rozeti yoksa): ikon her zaman küçük kalsın, kartı kaplamasın
    '.cart-item--free-gift .cart-item__gift-badge{display:inline-flex;align-items:center;gap:.6rem;align-self:flex-start}' +
    '.cart-item--free-gift .cart-item__gift-badge svg{width:1.6rem !important;height:1.6rem !important;flex:none}';
  var GIFT_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3.5-5-1.3C7 7 9.5 7 12 7zm0 0c1.5-3 5-3.5 5-1.3C17 7 14.5 7 12 7z"/></svg>';

  function addCss() {
    if (document.getElementById('ino-gift-lock-css')) return;
    var st = document.createElement('style');
    st.id = 'ino-gift-lock-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  function lockLabel() {
    var s = document.createElement('span');
    s.className = 'cart-item__gift-lock';
    s.innerHTML = GIFT_SVG + '<span>Hediye · 1 adet</span>';
    return s;
  }

  function mark() {
    var items = document.querySelectorAll('.cart-item');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      var gift = el.classList.contains('cart-item--free-gift');
      // Exclusive canta temada hediye olarak isaretlenmiyor: gorunen "Kendi Setin · Hediye" ozelliginden taninir
      if (!gift && (el.textContent || '').indexOf('Kendi Setin · Hediye') > -1) {
        el.classList.add('cart-item--free-gift');
        gift = true;
        if (!el.querySelector('.cart-item__gift-badge')) {
          var tmpl = document.querySelector('.cart-item__gift-badge');
          var badge = tmpl ? tmpl.cloneNode(true) : document.createElement('div');
          if (!tmpl) { badge.className = 'cart-item__gift-badge'; badge.innerHTML = GIFT_SVG + '<span>Hediyeniz</span>'; }
          var host = el.tagName === 'TR' ? (el.querySelector('td') || el) : el;
          host.insertBefore(badge, host.firstChild);
        }
      }
      if (!gift) continue;
      // Adet kutusunun yerine sabit etiket (her adet kutusu icin bir kez)
      var qs = el.querySelectorAll('quantity-input');
      for (var k = 0; k < qs.length; k++) {
        var q = qs[k];
        var prev = q.previousElementSibling;
        if (!(prev && prev.classList.contains('cart-item__gift-lock'))) q.parentNode.insertBefore(lockLabel(), q);
      }
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; mark(); });
  }

  function start() {
    addCss();
    mark();
    if (window.MutationObserver) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
